module.exports = __webpack_public_path__ + "assets/img/4-1.4c201a63.png";